import { useRef } from "react";

import useOnClickOutside from "@/shared/hooks/useOnClickOutside";
import Search from "../Input/Search";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";

export const Row = ({ className = "", ...props }) => (
  <div
    className={`cursor-pointer border-b-2 border-grey bg-table-blue px-2 py-2 hover:bg-primary hover:text-white ${className}`.trim()}
    style={{ borderRadius: "0.2px" }}
    {...props}
  />
);

interface Props {
  onSelectCustomer: (data: any) => void;
  customers: any[];
  search: string;
  setSearch: (value: string) => void;
  onClickSearch: () => void;
}

const CustomerFinder = ({
  customers,
  onSelectCustomer,
  search,
  setSearch,
  onClickSearch,
}: Props) => {
  const { t } = useTranslation();
  const ref = useRef();
  useOnClickOutside(ref, () => onSelectCustomer(null));

  return (
    <div
      ref={ref}
      className="mt-12 mb-4 w-full overflow-y-auto overflow-x-hidden"
    >
      <div className="relative my-2 flex gap-4">
        <Search
          onDeleteClick={() => {
            onSelectCustomer(null);
            setSearch("");
          }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t("posOrders.searchUserByNameSurnameTelephone")}
        />

        <Button
          isPending={false}
          variant="secondary"
          onClick={onClickSearch}
          className="w-1/4"
        >
          {t("posOrders.quickSearch")}
        </Button>
      </div>

      {customers?.length > 0 && (
        <div className="absolute z-100 w-[95%] h-120">
          {customers.map((customer) => (
            <Row
              key={customer.item_id}
              onClick={() => onSelectCustomer(customer)}
            >
              <div className="font-bold">{customer.name}</div>
              <div className="font-medium">{customer.telephone}</div>
              <div className="font-medium">{`${customer.street_name || ""} ${
                customer.house_number || ""
              } ${customer.house_number_extension || ""}`}</div>
            </Row>
          ))}
        </div>
      )}
    </div>
  );
};
export default CustomerFinder;
